import styled from "styled-components";

export const FooterWrap = styled.footer`
  width: 100%;
  background: var(--mp-bodyBackground, #f7f8fc);
  border-top: 1px solid rgba(23, 23, 23, 0.08);

  [data-marketplace-theme="dark"] &,
  .dark & {
    background: #0b0c0d;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }
`;

export const FooterInner = styled.div`
  max-width: 1680px;
  margin: 0 auto;
  padding: 64px 40px 0;
  box-sizing: border-box;
`;

export const FooterTop = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  gap: 48px;
  padding-bottom: 48px;

  @media (max-width: 991px) {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

export const FooterBrandCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FooterLogoMark = styled.div`
  width: 36px;
  height: 28px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const FooterLogoLine = styled.div<{ $wide?: boolean }>`
  height: 3px;
  border-radius: 2px;
  width: ${p => p.$wide ? "100%" : "60%"};
  background: var(--mp-headingColor, #171717);
`;

export const FooterTagline = styled.p`
  margin: 0;
  font-family: 'Liberation Serif', serif;
  font-size: 18px;
  line-height: 28px;
  color: var(--mp-featureDescColor, #434655);
  max-width: 320px;
  opacity: 0.85;
`;

export const LogoArea = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-right: 12px;
  align-self: flex-start;

  @media (max-width: 768px) {
    gap: 6px;
    margin-right: 0;
  }
`;

export const LogoImg = styled.img`
  height: 36px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;

  @media (max-width: 480px) {
    height: 28px;
  }
`;

export const LogoText = styled.span<{ $theme: "dark" | "light" }>`
  font-family: Montserrat, sans-serif;
  font-size: 18px;
  font-weight: 800;
  color: ${p => p.$theme === "dark" ? "#ffffff" : "#171717"};
  letter-spacing: -0.02em;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const LogoBadge = styled.span`
  font-size: 10px;
  font-weight: 700;
  background: #f1f2f6;
  color: #57606f;
  padding: 3px 8px;
  border-radius: 100px;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  [data-marketplace-theme="dark"] & {
    background: rgba(255, 255, 255, 0.08);
    color: #a4b0be;
  }

  @media (max-width: 1024px) {
    display: inline-block;
  }
`;

export const FooterCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FooterColTitle = styled.h5`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--mp-headingColor, #171717);
`;

export const FooterLinks = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const FooterLink = styled.li`
  a, span {
    font-family: 'Liberation Serif', serif;
    font-size: 16px;
    line-height: 24px;
    color: var(--mp-featureDescColor, #434655);
    text-decoration: none;
    cursor: pointer;
    opacity: 0.85;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid rgba(23, 23, 23, 0.08);
  padding: 24px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;

  [data-marketplace-theme="dark"] &,
  .dark & {
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }
`;

export const FooterCopyright = styled.p`
  margin: 0;
  font-family: 'Liberation Serif', serif;
  font-size: 16px;
  color: var(--mp-featureDescColor, #434655);
  opacity: 0.7;
`;

export const FooterSocialRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const FooterSocialBtn = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--mp-featureDescColor, #434655);
  opacity: 0.6;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }

  svg,
  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
`;
